import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SERVICES } from "../lib/data";

export const Services = () => {
    const prefix = "//";
    return (
        <section id="services" data-testid="services-section" className="relative py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-3xl mb-16">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-4">
                        {prefix} Services
                    </div>
                    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
                        Everything your business needs to{" "}
                        <span className="text-gradient-cyan">show up online</span>.
                    </h2>
                    <p className="mt-6 text-lg text-slate-400 leading-relaxed">
                        One person. End-to-end. From the first sketch to the final search-engine ranking.
                        No agency overhead, no junior hand-offs.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {SERVICES.map((s, i) => {
                        const Icon = Icons[s.icon] || Icons.Sparkles;
                        return (
                            <motion.div
                                key={s.title}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.5, delay: i * 0.06 }}
                                whileHover={{ y: -6 }}
                                data-testid={`service-card-${i}`}
                                className="group relative p-7 rounded-2xl border border-white/5 bg-[#0a1024] hover:border-cyan-400/40 transition-all overflow-hidden"
                            >
                                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/0 to-blue-600/0 group-hover:from-cyan-500/5 group-hover:to-blue-600/5 transition-all" />
                                <div className="relative">
                                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-400/20 to-blue-600/20 border border-cyan-400/20 flex items-center justify-center mb-6 group-hover:shadow-lg group-hover:shadow-cyan-500/20 transition-all">
                                        <Icon size={20} className="text-cyan-400" />
                                    </div>
                                    <h3 className="text-xl font-semibold mb-3">{s.title}</h3>
                                    <p className="text-slate-400 leading-relaxed text-[15px]">{s.desc}</p>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
